import React, { useState, useEffect } from 'react';
import axiosPost from '../helpers/axios-helper';
import '../styles/SponsoredBanners.css';

/**
 * Paid placements, uploaded from the dashboard.
 *
 * The server decides what is live — active, and inside its run of dates — so
 * nothing expired can reach the page even if this component is cached. When
 * there is nothing to show it renders nothing at all rather than an empty
 * grey band, so a page with no sponsors does not look broken.
 */
export default function SponsoredBanners({ placement = 'home' }) {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    const controller = new AbortController();
    axiosPost(
      'banners/live',
      { 'Content-Type': 'application/json' },
      { placement },
      (resp) => {
        if (resp?.success) setBanners(resp.data.banners || []);
      },
      controller
    );
    return () => controller.abort();
  }, [placement]);

  if (banners.length === 0) return null;

  return (
    <aside className="sponsored" aria-label="Sponsored">
      <p className="sponsored-label">Sponsored</p>

      {banners.map((banner) => {
        const picture = (
          <picture>
            {banner.image_mobile && (
              <source media="(max-width: 768px)" srcSet={banner.image_mobile} />
            )}
            <img
              className="sponsored-image"
              src={banner.image}
              alt={banner.alt_text || ''}
              loading="lazy"
            />
          </picture>
        );

        // A banner without a link is still worth showing; it just does not click
        return banner.link_url ? (
          <a
            key={banner.id}
            className="sponsored-item"
            href={banner.link_url}
            target="_blank"
            rel="noreferrer sponsored"
          >
            {picture}
          </a>
        ) : (
          <div key={banner.id} className="sponsored-item">{picture}</div>
        );
      })}
    </aside>
  );
}
